import { CxEvent } from '@spartacus/core';

export class FbqGgCartAddEntrySuccessEvent extends CxEvent {
  event?: string;
}
